/**
 * The Account API `user` call failed, so there is no profile to bootstrap with.
 * `status` is the HTTP status (0 for a network failure) and `message` is whatever the API
 * said, which for the common case is the SQL error text about a missing staff record.
 */
export class UserProfileLoadError extends Error {
	constructor(
		public readonly status: number,
		message: string,
		/** The API error body's `type` (e.g. the exception class), when the body carried one. */
		public readonly apiErrorType?: string
	) {
		super(message);
		this.name = 'UserProfileLoadError';
	}

	/**
	 * The account exists in Okta/Saviynt but has no staff record in myNHA yet. Matching the SQL
	 * error prose is a stopgap until the Account API returns a structured code for this case.
	 */
	get isMissingStaffRecord(): boolean {
		return /No staff member was found/i.test(this.message);
	}
}
